import dayjs from 'dayjs'

// 导入本地化语言
import 'dayjs/locale/zh-cn'

// 导入格式化插件
import localizedFormat from 'dayjs/plugin/localizedFormat'

// 导入比较时间插件
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

// 导入比较时间插件
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

import duration from 'dayjs/plugin/duration'

dayjs.extend(localizedFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(duration)
dayjs.locale('zh-cn') // 使用中文

export default dayjs
